export const agreementDurationTypeViewMapping: Record<string, string> = {
  no_set_time: 'No set time duration',
  single_use: 'Single use',
  specific_time: 'Specific time duration',
}

export const discountTypeViewMapping: Record<string, string> = {
  DISCOUNT: 'Discount',
  INDIVIDUAL_PRICING: 'Upfront payment',
  FLEXIBLE_PAYMENT_TERMS: 'Installment plan',
  USAGE_PRICING: 'Usage pricing',
}
